import { Component, Input } from '@angular/core';
import { Output, EventEmitter } from '@angular/core';
import { SearchTarget } from '@app/cp/shared/enums/SearchTarget';
import { CellClickEvent } from '@progress/kendo-angular-grid';

@Component({
    selector: 'cp-dispatch-search-results',
    templateUrl: './dispatch-search-results.component.html',
    styleUrls: ['./dispatch-search-results.component.scss'],
    standalone: false
})
export class DispatchSearchResultsComponent {
  SearchTarget: SearchTarget;
  @Input() searchFilter: string;
  @Input() loading: boolean = false;
  @Input() resultsData: any;
  @Input() searchTarget: SearchTarget = SearchTarget.dispatch;
  @Input() isZuggitUser: boolean = false;
  skip: number = 0;

  @Output() cellClickEvent = new EventEmitter<CellClickEvent>();
  @Output() closeSearchResultsEvent = new EventEmitter<null>();

  cellClick(dataItem: CellClickEvent) {
    this.cellClickEvent.emit(dataItem);
  }

  onCloseSearchResults() {
    this.closeSearchResultsEvent.emit(null);
  }
}
